import React from "react";
import {
  humanCalculators,
} from "./ConstantsHumanCalculator";
function MainCalculatorsList() {
  let calculatorsList = humanCalculators;
  let calculatorName = "Kalkulator Waktu dan Tanggal";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.map((item, index) => item.showMain && (
            <li key={index}>
              <a href={item.link} className="item-link">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <div style={{ textAlign: "center" }}>
          <a
            className="btn btn-success"
            style={{ width: "90%" }}
            href={"/id/date-time-calculators/"}
          >
            Lainnya
          </a>
          <hr />
        </div>
         </div>
</div>
  );
}
export default MainCalculatorsList;